import { useBiddingContext } from '@/features/bidding/contexts/BiddingContext'
import { usePortfoliosQuery } from '@/features/bidding/hooks/usePortfoliosQuery'
import type { Portfolio } from '@/features/bidding/types/bid'
import getBiddingFlow from '@/features/bidding/utils/getBiddingFlow'
import type { GroupedBidParams } from '@/features/bidding/utils/groupedBidParams/buildBiddingLinks'

type Options = {
  enabled?: boolean
}

export function useBidOfferPortfolio(groupParams: GroupedBidParams, options?: Options) {
  const { selectedCountry } = useBiddingContext()
  const { portfolios } = usePortfoliosQuery({ countryCode: selectedCountry })

  const portfolio = portfolios ? portfolios.find((p: Portfolio) => p.code === groupParams.portfolioCode) : undefined

  const biddingFlow = portfolio ? getBiddingFlow(portfolio) : undefined

  return {
    portfolio,
    biddingFlow,
    isLoading: !portfolios && (options?.enabled ?? true),
  }
}
